import React, { useState, useEffect } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import subCategoryService from "../services/sub-category";
import brandService from "../services/brand";
import keys from "../store/keys";
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import utils from "../utils/utils";
import constants from "../utils/constants";
import Collapsible from 'react-collapsible';

function Filters({ session, setKey, ...props }) {
	const [categories, setCategories] = useState([]);
	const [brands, setBrands] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [selectedBrands, setSelectedBrands] = useState([]);
	const [price, setPrice] = useState({ min: constants.minPrice, max: constants.maxPrice });

	useEffect(() => {
		let v = {
			min: constants.minPrice,
			max: constants.maxPrice
		};
		setPrice(v);
	}, []);

	useEffect(() => {
		if (session.searchCategoryId) {
			subCategoryService.getAll("", session.searchCategoryId)
				.then(result => {
					if (result.data) {
						setCategories(result.data);
					}
				});
		}
		else {
			setCategories([]);
			setKey(keys.searchCategories, "");
		}
	}, [session.searchCategoryId]);

	useEffect(() => {
		brandService.getAll(session.token, "")
			.then(result => {
				if (result.data) {
					setBrands(result.data);
				}
			});
	}, []);

	useEffect(() => {
		setPrice({
			min: parseInt(session.searchPriceMin),
			max: parseInt(session.searchPriceMax)
		});
	}, [session.searchPriceMin, session.searchPriceMax]);

	useEffect(() => {
		if (session.searchBrands === "") {
			setSelectedBrands([]);
		}
	}, [session.searchBrands]);

	useEffect(() => {
		if (session.searchCategories === "") {
			setSelectedCategories([]);
			document.querySelectorAll(`.form-check`).forEach(k => {
				k.querySelector('input').checked = false;
			});
		}
		else {
			setSelectedCategories([]);
			setSelectedCategories([session.searchCategories]);
			setTimeout(() => {
				document.querySelectorAll(`.form-check`).forEach(k => {
					let label = k.querySelector('label').innerText;
					if (session.searchCategories.indexOf(",") === -1) {
						console.log("if");
						if (label.toLowerCase() === session.searchCategories.toLowerCase()) {
							k.querySelector('input').checked = true;
						}
						else {
							k.querySelector('input').checked = false;
						}
					}
					else {
						console.log("else: ", session.searchCategories);
						session.searchCategories.split(",").forEach(f => {
							if (label.toLowerCase() === f.toLowerCase()) {
								k.querySelector('input').checked = true;
							}
							else {
								// k.querySelector('input').checked = false;
							}
						});
					}
				});
			}, 200);
		}
	}, [session.searchCategories]);

	const handleSelectCategory = (checked, val) => {
		let t = session.searchCategories.length > 0 ? session.searchCategories.split(",") : [];
		if (checked) {
			if (!t.includes(val)) {
				t.push(val);
			}
		}
		else {
			t = t.filter(k => k !== val);
		}

		setSelectedCategories(t);
		setKey(keys.searchCategories, t.join(","));
	}

	const handleSelectBrand = (checked, val) => {
		let t = selectedBrands;
		if (checked) {
			t.push(val);
		}
		else {
			t = t.filter(k => k !== val);
		}
		setSelectedBrands(t);
		setKey(keys.searchBrands, t.join(","));
	}

	const renderSubCategories = () => {
		return categories.map(k => {
			return (
				<li key={k._id}>
					<div className="form-check">
						<input
							className="form-check-input"
							type="checkbox"
							id={k._id}
							onClick={e => handleSelectCategory(e.target.checked, k.title)}
						/>
						<label
							className="form-check-label"
							htmlFor={k._id}>
							{k.title}
						</label>
					</div>
				</li>
			);
		});
	}

	const renderBrands = () => {
		return brands.map(k => {
			return (
				<li key={k._id}>
					<div className="form-check">
						<input
							className="form-check-input"
							type="checkbox"
							id={k._id}
							onClick={e => handleSelectBrand(e.target.checked, k.title)}
						/>
						<label
							className="form-check-label"
							htmlFor={k._id}>
							{k.title}
						</label>
					</div>
				</li>
			);
		});
	}

	const handleChangePrice = value => {
		setPrice(value);
		let t = value.max;
		console.log(t);
		if(t === constants.maxPrice) {
			console.log(document.querySelector(`.input-range__label-container`));
			document.querySelector(`.input-range__label-container`).innerHTML = `${t}+`;
		}
	}

	const handleChangePriceComplete = value => {
		setKey(keys.searchPriceMin, value.min);
		setKey(keys.searchPriceMax, value.max);
	}

	const Trigger = props => {
		return (
			<div className="row">
				<div className="col text-start">
					{props.title}
				</div>
				<div className="col text-end">
					<i className={`fa-solid ${props.icon}`}></i>
				</div>
			</div>
		)
	}

	const handleHome = e => {
		e.preventDefault();
		document.querySelector(`.nav-categories .browse-all a`).click();
	}

	const handleCategory = (e, cat) => {
		e.preventDefault();

		const id = `nav-link-${utils.replaceAll(" ", "", cat)}`.toLowerCase();
		document.querySelectorAll(`.nav-categories .nav-item`).forEach(k => k.classList.remove("nav-categories-active"));
		document.querySelector(`.nav-categories .browse-all`).classList.remove("nav-categories-active");
		document.querySelector(`.nav-categories #${id}`).click();
	}

	const handleSubCategory = (e, cat, sub) => {
		e.preventDefault();
		setKey(keys.searchCategories, ``);
		setKey(keys.searchCategories, sub);
		// const id = `nav-link-${utils.replaceAll(" ", "", cat)}`.toLowerCase();
		document.querySelectorAll(`.nav-categories .nav-item`).forEach(k => k.classList.remove("nav-categories-active"));
		document.querySelector(`.nav-categories .browse-all`).classList.remove("nav-categories-active");
		// document.querySelector(`.nav-categories #${id}`).click();
	}

	const renderBreadcrumbs = () => {
		const length = session.searchCategories.split(",").length;
		return (<>
			<span onClick={handleHome}>Home</span>
			<i className="fa-solid fa-chevron-right"></i>
			{session.searchCategoryId !== "" && <><span onClick={e => handleCategory(e, session.searchCategory)}>{session.searchCategory}</span><i className="fa-solid fa-chevron-right"></i></>}
			{session.searchCategories.split(",").map((k, idx) => {
				if (idx < length - 1) {
					return <span key={idx} onClick={e => handleSubCategory(e, session.searchCategory, k)}>{k}<i className="fa-solid fa-chevron-right"></i></span>
				}
				else {
					return <span key={idx} onClick={e => handleSubCategory(e, session.searchCategory, k)}>{k}</span>
				}
			})}
		</>);
	}

	return (
		<div className="filters mt-30">
			<div className="row">
				<div className="col">
					<div className="breadcrumbs mb-30" style={{}}>
						{renderBreadcrumbs()}
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<Collapsible
						trigger={<Trigger title="Categories" icon="fa-chevron-down" />}
						triggerWhenOpen={<Trigger title="Categories" icon="fa-chevron-up" />}
						open={session.searchCategoryId !== "" ? true : false}
						triggerDisabled={!session.searchCategoryId}
					>
						{/* {!session.searchCategoryId && <small className="small">Select a category in header</small>} */}
						{renderSubCategories()}
					</Collapsible>
					<hr />
					<div className="mt-20"></div>
					<Collapsible
						trigger={<Trigger title="Brands" icon="fa-chevron-down" />}
						triggerWhenOpen={<Trigger title="Brands" icon="fa-chevron-up" />}>
						{renderBrands()}
					</Collapsible>
					<hr />
					<div className="mt-20"></div>
					<Collapsible
						trigger={<Trigger title="Price" icon="fa-chevron-down" />}
						triggerWhenOpen={<Trigger title="Price" icon="fa-chevron-up" />}>
						<InputRange
							maxValue={constants.maxPrice}
							minValue={constants.minPrice}
							value={price}
							step={10}
							formatLabel={value => utils.formatSlider(value, session.selectedRegion ? session.selectedRegion.currency : "EUR")}
							onChange={handleChangePrice}
							onChangeComplete={handleChangePriceComplete} />
					</Collapsible>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
